import { render, staticRenderFns } from "./SimplePageNorm.vue?vue&type=template&id=20dc1b68&scoped=true&"
import script from "./SimplePageNorm.vue?vue&type=script&lang=js&"
export * from "./SimplePageNorm.vue?vue&type=script&lang=js&"
import style0 from "./SimplePageNorm.vue?vue&type=style&index=0&id=20dc1b68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc1b68",
  null
  
)

export default component.exports